import React, { FC } from "react";
import { type Control, Controller } from "react-hook-form";
import { TextField } from "@mui/material";

interface ControlledTextFieldProps {
  control: Control<any>;
  name: string;
  placeholder: string;
  variant?: "filled" | "outlined" | "standard";
  fullWidth?: boolean;
  sx?: object;
  disabled?: boolean;
  multiline?: boolean;
  readOnly?: boolean;
  inputProps?: object;
  onlyDigits?: boolean;
}

/** Textfield wrapped with react-hook-form Controller
 *  so we don't have to wrap it every time we use it,
 * just need to pass the schema and other required props
 */

const ControlledTextField: FC<ControlledTextFieldProps> = ({
  control,
  name,
  placeholder,
  variant = "outlined",
  fullWidth = true,
  sx = {},
  disabled = false,
  multiline = false,
  readOnly = false,
  inputProps = {},
  onlyDigits = false,
}) => (
  <Controller
    control={control}
    name={name}
    render={({ field, fieldState }) => (
      <TextField
        name={field.name}
        value={field.value}
        fullWidth={fullWidth}
        placeholder={placeholder}
        variant={variant}
        onChange={(e) => {
          if (onlyDigits) e.target.value = e.target.value.replace(/\D/g, "");
          field.onChange(e);
        }}
        error={!!fieldState.error?.message}
        helperText={fieldState.error?.message}
        sx={{ maxLines: 5, ...sx }}
        disabled={disabled}
        multiline={multiline}
        minRows={3}
        inputProps={{ readOnly: readOnly, ...inputProps }}
      />
    )}
  />
);

export default ControlledTextField;
